export enum RunAuditWorkpapersActions {
    ShowModal = 'RUNAUDITWORKPAPERS/ShowModal',
    HideModal = 'RUNAUDITWORKPAPERS/HideModal',
}

export interface IShowRunAuditWorkpapersModal {
    readonly type: RunAuditWorkpapersActions.ShowModal;
    readonly workspaceId: string;
    readonly submissionId: string;
    readonly financialRecordId: string;
}

export interface IHideRunAuditWorkpapersModal {
    readonly type: RunAuditWorkpapersActions.HideModal;
}

export type KnownAction =
    IShowRunAuditWorkpapersModal |
    IHideRunAuditWorkpapersModal;
